/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActivityTracker } from '@/services/activityTracker/adapters/contracts/activity-tracker';

// console.logs are left for future debugs
export class LocalTracker implements ActivityTracker {
  identifyUser = (): void => {
    // console.log('Identifying user.');
  };

  setUser = (id: string | null): void => {
    // console.log(`Setting user id for ${id}`);
  };

  trackEvent = (event: string, properties: Record<string, unknown>): void => {
    // console.log(`Tracking ${event} with properties:`, properties);
  };

  unsetUser = (): void => {
    // console.log('Un-setting user.');
  };
}
